module.exports = __webpack_public_path__ + "962aa3d022bb7c41fae48fc609cce2c0.svg";